export const resolveTypedFullName = (
  originalName: string | undefined,
  typedBaseName: string | undefined,
  isFolder: boolean
): string | undefined => {
  const base = typedBaseName?.trim();
  if (!base) return undefined;
  if (isFolder || !originalName?.includes('.')) return base;
  const extension = originalName.split('.').pop();
  return `${base}.${extension}`;
};
